export default "__VITE_ASSET__2b2ef57f__"